module.exports = __webpack_public_path__ + "img/cooperative1_logo1.8d29d35f.jpg";